interface BaseItem {
  label: string
}

interface ExternalLink extends BaseItem {
  type: 'external'
  href: string
}
interface InternalLink extends BaseItem {
  type: 'internal'
  to: string
  notification?: string
}
interface LocaleLink extends BaseItem {
  locale: string
}

type NavLink = ExternalLink | InternalLink
export interface SubNav extends BaseItem {
  type: 'subnav'
  links: NavLink[]
  highlight?: NavLink & {body: string}
}
export interface SubNavWork extends BaseItem {
  type: 'subnav-work'
  links: NavLink[]
  highlight?: NavLink & {body: string}
}

export interface LocaleNav extends BaseItem {
  type: 'locale'
  locales: LocaleLink[]
}

export type NavItem = ExternalLink | InternalLink | SubNav | SubNavWork
export type Nav = NavItem[]

export function useNav(): Nav {
  const {t} = useI18n()
  const p = useLocalePath()

  const {nav} = useNavData()

  const {industries, technologies} = unref(nav)

  return [
    {
      type: 'subnav',
      label: t('header.nav.company'),
      highlight: {
        type: 'internal',
        label: t('header.nav.about'),
        body: t('header.nav.about_body'),
        to: p('/company'),
      },
      links: [
        {
          type: 'internal',
          label: t('header.nav.blog'),
          to: p('/blog'),
        },
        {
          type: 'internal',
          label: t('header.nav.free_resources'),
          to: p('/free-resources'),
        },
        {
          type: 'internal',
          label: t('header.nav.technical_bytes'),
          to: p('/technical-bytes'),
        },
        // {
        //   type: 'internal',
        //   label: t('header.nav.careers'),
        //   to: p('/careers'),
        //   notification: jobs.length ? String(jobs.length) : undefined,
        // },
        {
          type: 'internal',
          label: t('header.nav.startups'),
          to: p('/startups'),
        },
        {
          type: 'internal',
          label: t('header.nav.impressum'),
          to: p('/impressum'),
        },
      ],
    },
    {
      type: 'subnav-work',
      label: t('header.nav.services'),
      links: [
        {
          type: 'internal',
          label: t('header.nav.product_discovery_workshop'),
          to: p('/product-discovery-workshop'),
        },
        {
          type: 'internal',
          label: t('header.nav.managed_projects'),
          to: p('/managed-projects'),
        },
        {
          type: 'internal',
          label: t('header.nav.dedicated_team'),
          to: p('/dedicated-team'),
        },
      ],
    },
    {
      type: 'subnav-work',
      label: t('header.nav.technologies'),
      links: technologies
        .filter(o => o.slug)
        .map(technology => ({
          type: 'internal' as const,
          label: technology.name,
          to: p(`/tech/${technology.slug}`) || '',
        })),
    },
    {
      type: 'subnav',
      label: t('header.nav.projects'),
      highlight: {
        type: 'internal' as const,
        label: 'Logistics',
        body: t('logistics.nav_paragraph'),
        to: p('/logistics'),
      },
      links: industries
        .filter(industry => industry.slug && industry.slug !== 'logistics')
        .map(industry => ({
          type: 'internal' as const,
          label: industry.name,
          to:
            industry.slug === 'healthcare'
              ? '/custom-healthcare-software-development'
              : p(`/projects/${industry.slug}`) || '',
        })),
    },
  ]
}

export const flagNames = {
  de: 'de',
  en: 'gb',
  ro: 'ro',
} as Record<string, string>

export function toFlagIcon(code: string) {
  return `flag:${flagNames[code]}-4x3`
}
